import type { Ref } from 'react'
import type { InputProps } from './Input.types'
import './Input.scss'

/**
 * Input Component
 *
 * Reusable input field with consistent styling across the application.
 * Supports error states, focus states, and all standard HTML input attributes.
 *
 * @example
 * // Basic usage
 * <Input type="email" placeholder="E-Mail" />
 *
 * @example
 * // With error state
 * <Input type="email" placeholder="E-Mail" error />
 *
 * @example
 * // With ref for auto-focus
 * const inputRef = useRef<HTMLInputElement>(null)
 * <Input ref={inputRef} type="email" placeholder="E-Mail" />
 */
export function Input({
  error = false,
  className = '',
  ref,
  ...props
}: InputProps & { ref?: Ref<HTMLInputElement> }) {
  const inputClassName = `input ${error ? 'input--error' : ''} ${className}`.trim()

  return <input ref={ref} className={inputClassName} spellCheck={false} {...props} />
}
